import { DynamicObjectInterface } from '../type';
import { AxiosUtilsType, axiosGet, axiosPost } from './axiosUtils';
import './axiosInterceptor';

const ValidationService = {
  async validateOrderNumber(payload: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPost(`orderValidation`, payload);
  },

  async validatePromoOrder(payload: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPost(`promoOrderValidation`, payload);
  },

  async validateChallengeEntitlement(payload: DynamicObjectInterface): AxiosUtilsType {
    return await axiosPost(`promoValidation/challenge`, payload);
  },

  async searchChallengeParticipant(promoChallengeId: string, name: string): AxiosUtilsType {
    return await axiosGet(
      `promoValidation/participant?promoChallengeId=${promoChallengeId}&name=${encodeURIComponent(name)}`,
    );
  },
};
export default ValidationService;
